<template>
  <div class="login">
   <Title titleName='申请入驻商家' iconLeft="back"/>
<img class="banner" src="../../assets/banner.png" />
	<div class="login_user">
		<div class="user_input">
			
		<div class="lab"><img src="../../assets/y1.png">店铺名称</div> <input v-model="reg.store_name" placeholder="请输入" />
		</div>
		<div class="user_input"  @click="showPicker = true">
			
			<div class="lab"><img src="../../assets/y2.png">城市  </div><input v-model="ying"  placeholder="请选择" /><div class="ip"><img src="../../assets/ip.png"></div>
			
		</div>
	<div class="user_input">
		
	<div class="lab"><img src="../../assets/y3.png">手机号</div> <input v-model="reg.phone" placeholder="请输入" />
	</div>
	
	
	<div class="user_input">
		
		<div class="lab"><img src="../../assets/y4.png">密码 </div><input type="password" v-model="reg.password"  placeholder="请输入" />
		
	</div>
	<div class="user_input">
		
		<div class="lab"><img src="../../assets/y4.png">确认密码 </div><input  type="password" v-model="reg.repassword"  placeholder="请输入" />
		
	</div>

	
		
	
	
		
	</div>
	<div class="h-txt">
		<textarea v-model="reg.cinemas" placeholder="请输入擅长的影院…"></textarea>
	</div>
	<div class="login_bt">
		<van-button @click="submitForm()" round color="#FF5E00" block>申请入驻</van-button>
	</div>
		


	<van-popup v-model="showPicker" position="bottom">
		<van-area :area-list="areaList" @confirm="onConfirm" :columns-num="2"  @cancel="showPicker = false"/>
		
</van-popup> 

	
  </div>
</template>
<script>
import Title from "@/common/title";
import { Toast } from 'vant';	
import AeraInfo from "../../common/area.js";
export default {
  components: {
    Title

  },
  data() {
    return {
		areaList: AeraInfo,
		active: 1,
		id:'',
		news:'',
		file:'',
		ying:'',
		 showPicker:false,
		 show:false,
		reg: {
			store_name:'',
			city_code:'',
			phone:'',
			password:'',
			repassword:'',
			cinemas:''
			         
		      },
    
    };
  },mounted() {
	  
	if(this.$route.query.id){
		this.reg.id = this.$route.query.id
		this.sandCate()
	}
	  
  	
	this.sandMate()
	this.sandCase()
  },methods:{
	   onConfirm(value) {
		  
	  
		
		   this.reg.city_code=value[1].code
		   this.ying=value[1].name
	       this.showPicker = false;
	      },
	  submitForm() {
	  				
	  		
	          
	          this.$axios({
	            method: "post",
	            url: "stores/register",
	            data: this.reg,  
	          }).then((res) => {
	          	let data=res.data;
	          			
	          	if(data.code==200){
	  						
	  			  Toast(data.message);
				  this.$router.back()
	    
	          		
	          	}else{  
	  						  Toast(data.message);
	  						      
	  					}
	           
	          });
	  				 
	  				 
	         
	       
	       }
  }
};
</script>
<style lang="scss" scoped>

.login{
	width: 100%;
	height: 100%;
	
	.logo{
		width: 266px;
		height: 156px;
		margin: 150px;
	}
	.banner{
		width: 100%;
	}
	.login-button {
	  background: #F8F8F8;
	
	  .han{
		  background: #6DAD19;
	  }
	 
	}
	
	.login_user{
		width: 100%;
		height: auto;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		align-items: center;
		justify-content: flex-start;
	}
.login_bt{
		
		width: 631px;
		margin: 50px auto;
		margin-bottom: 200px;
	}
	.login_at{
			display: flex;
			width: 631px;
			margin: 50px auto;
			justify-content: space-between;
		
		}
		.h-txt{
			width: 100%;
			background: #ffffff;
			margin-top: 20px;
			display: flex;
			align-items: center;
			justify-content: center;
			textarea{
				margin: 20px 0;
				width: 660px;
				height: 200px;
				border: none;
			}
		}
	.login_user .user_input{
		width:680px;
		color: #000000;
		font-size: 28px;
		height: 100px;
		border-bottom: 1px solid #eee;
		display: flex;
		margin-left: 20px;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		padding-right: 20px;
		.lab{
			width: 250px;
			display: flex;
			align-items: center;
			img{
				width: 32px;
				height: 32px;
				margin-right: 10px;
			}
		}
		span{
			color: #E72E34;
			margin-left: 10px;
			
		}
		input{
			text-align: right;
		
		}
		.ip{
			width: 30px;
			img{
				width: 100%;
			}
		}
	
	}
	.login_user .user_input .input_icon{
		width: 39px;
		height: 46px;
		margin-right: 22px;
		margin-left: 16px;
	}
	.login_user .user_input input{
		flex: 1;
		height: 46px;
		font-size: 22px;
		color: #6d6d6d;
		background:none;  
		outline:none;  
		border:none;
	}
	.login_user .user_input input:focus{  
		border:none;
	}
	.login_user .user_input .show_pwd_icon{
		width: 32px;
		height: 20px;
		cursor: pointer;
		margin-left: 65px
	}
}

 .pro-tit{
	 background: #FFFFFF;
	 text-align: center;
	 line-height: 40px;
	 padding: 20px 0;
	 h3{
		 font-size: 36px;
	 }
	 p{
		 font-size: 24px;
	 }
 }
</style>